import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import {
  Grid2 as Grid,
  FormGroup,
  Grid2Props,
  Box,
  Typography,
  FormHelperText,
} from "@mui/material";
import { singleGridItem } from "../defaultStyles";
import { useInputFullName } from "../subForms/NamePrefixContext";
import FormLabel from "../../common/base/FormLabel";
import UserAttributeMetadataPaper from "../../attributeMetadata/UserAttributeMetadataPaper";
import { SystemEntityCollections } from "../../../../shared/enums/shared-enums";
import EntityReferenceComponent from "../../../entitiesReferences/EntityReferenceComponent";
import {
  StyledBox,
  StyledFormControl,
} from "../../../entitiesReferences/EntitySelectionInput.styles";
import clsx from "clsx";

interface FormEntityReferenceStaticFieldProps extends Grid2Props {
  name?: string;
  label: string;
  placeholder?: string;
  entityCollection: SystemEntityCollections;
  labelActions?: React.ReactNode;
}

const FormEntityReferenceStaticField: React.FC<
  FormEntityReferenceStaticFieldProps
> = ({ name, label, labelActions, placeholder, entityCollection, ...grid }) => {
  const { control } = useFormContext();
  const fullName = useInputFullName(name);

  return (
    <Grid {...singleGridItem} {...grid}>
      <UserAttributeMetadataPaper name={fullName}>
        <Controller
          name={fullName}
          control={control}
          render={({ field, fieldState }) => {
            return (
              <FormGroup>
                <FormLabel
                  label={label}
                  name={fullName}
                  actions={labelActions}
                />
                <StyledFormControl error={!!fieldState.error} fullWidth>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <StyledBox
                      error={!!fieldState.error}
                      className={clsx("Mui-static-field")}
                    >
                      <Box flexGrow={1} p={1.5}>
                        {field.value && field.value._key ? (
                          <EntityReferenceComponent
                            entity={field.value}
                            entityCollection={entityCollection}
                            showCatalogNo={false}
                          />
                        ) : (
                          <Typography color="text.secondary" variant="body2">
                            {placeholder || "No selection made"}
                          </Typography>
                        )}
                      </Box>
                    </StyledBox>
                  </Box>

                  {fieldState.error?.message && (
                    <FormHelperText>{fieldState.error?.message}</FormHelperText>
                  )}
                </StyledFormControl>
              </FormGroup>
            );
          }}
        />
      </UserAttributeMetadataPaper>
    </Grid>
  );
};

export default FormEntityReferenceStaticField;
